<template>
    <div class="AddPlayers content">
        <div class="addPlayer">
            <div v-if="!teamIsFull">
                <div class="addText">PLAYERS</div>
                <div style="color: orange;">Enter BattleTag to add players (e.g. GenjiMain-1532)</div>
                <div class="error" v-if="status=='error'">{{errorMessage}}</div>
                <AddBox v-model="battleTag" v-bind:placeholderText="placeholderText" v-bind:status="status" v-on:add="addPlayer"></AddBox>
            </div>
            <PlayerCard v-for="player in reversedPlayersList" :key="player.name" v-bind:player="player" v-bind:teamId="team.id" v-bind:edit="true"></PlayerCard>
            <div class="addPlayerBtn">
                <button type="button" class="buttonBigStyle" v-on:click="done">DONE</button>
            </div>
        </div>
    </div>
</template>

<script>
import PlayerCard from '@/components/PlayerCard.vue'
import AddBox from '@/components/AddBox.vue'
export default {
  name: 'AddPlayers',
  components: {
      PlayerCard,
      AddBox,
  },
  props: ["team"],

  data: function(){
    return {
        battleTag: "",
        placeholderText: "ENTER BATTLETAG",
        status: "ok", // change to "ok"
        errorMessage: "Something went wrong. Please try again.",
        editedTeam: false
    }
  },

  computed: {
      teamIsFull(){
          return (this.team.players.length === 6);
      },
      reversedPlayersList() {
        return this.team.players.slice().reverse();
    }
  },

  methods: {
      addPlayer(){
          this.status = "loading";
          var parameters = {
              battleTag: this.battleTag,
              teamId: this.team.id,
              callback: this.setStatusDone,
              errorCallback: this.setStatusError
          }
          this.$store.dispatch('getPlayerFromAPI',parameters)
          
      },

      done(){
          this.$router.go(-1);
      },

      setStatusDone(){
          this.status = "done";
          this.battleTag = "";
          this.editedTeam = true;
          window.setTimeout(this.setStatusOk,1000);
      },

      setStatusError(status){
          if(status == 404){
              this.errorMessage = "Couldn't find any player with that BattleTag.";
          }
          this.status = "error";
      },

      setStatusOk(){
          this.status = "ok";
      }
  }
}
</script>


<style scoped>

/* The grid container
.AddPlayers {
  display: grid;
  grid-template-areas:
  'left banner addPlayer rigth';
  grid-column-gap: 20px;
  align-content: auto;
  margin-top: 20px;
}*/

.addPlayer{
    grid-area: addPlayer;
}

.addPlayerBtn{
    grid-area: addPlayer;
    align-self: center;
    justify-self: center;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align:center;
}

.playerBanner{
    grid-area: banner;
}
.playerBanner > img{
  width: 500px;
  border-radius: 8px;
}

.error{
    color: red;
}
.greyButton{
    background: transparent;
    border-style: dashed;
    border-color: orange;
    color: orange;
}
.inputHolder{
    display: grid;
    align-items: center;
    grid-column-gap: 20px;
    grid-template-areas:
    'input loader';
}

.loaderElement{
    grid-area: loader;
    margin: 20px
}

.input{
    grid-area: input;
}
.addText{
    margin-top: 10px;
}


@media (max-width: 600px) {
  .addText{
      font-size: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddPlayers.vue